import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
import { CAMP_REVIEW_NAMES } from './summerCampContent';
export function SummerCampReviews() {
  return <section className="py-24 bg-off-white" data-id="element-3289">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3290">
        <h2 className="text-4xl md:text-5xl text-ink text-center mb-16" data-id="element-3291">
          What Families Say About Storm Taekwondo
        </h2>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-3292">
          {STORM_REVIEWS.filter(r => CAMP_REVIEW_NAMES.includes(r.name)).map(review => <ReviewCard key={review.name} quote={review.quote} name={review.name} label={review.label} data-id="element-3293" />)}
        </div>
      </div>
    </section>;
}